import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import ForgotPasswordModal from 'pages/Login/ForgotPasswordModal';
import {resetPasswordAction, closeResetPasswordModalAction, resetPasswordValueChangedAction} from "./actions";
import forgotPasswordFormConfig from './forgotPasswordFormConfig';
import {formDataManager} from "hoc/formDataManager";

const mapStateToProps = (state) => ({
    modalOpen: state.user.resettingPassword,
    error: state.user.error,
    showSuccessMessage: state.user.sendSuccess
});

const mapDispatchToProps = (dispatch) => ({
    onSaveData: (data) => dispatch(resetPasswordAction(data)),
    handleClose: () => dispatch(closeResetPasswordModalAction()),
});

const ForgotPasswordModalContainerConnected = connect(mapStateToProps, mapDispatchToProps);

const ForgotPasswordModalLifeCycle = lifecycle({
    componentWillUnmount: function () {
        this.props.handleClose();
    }
});

let ForgotPasswordFromDataManager = formDataManager({
  email: ""
}, forgotPasswordFormConfig);

const ForgotPasswordModalContainer = compose(
    ForgotPasswordModalContainerConnected,
    ForgotPasswordModalLifeCycle,
    ForgotPasswordFromDataManager
)(ForgotPasswordModal);

export default ForgotPasswordModalContainer;



// WEBPACK FOOTER //
// ./public/pages/Login/ForgotPasswordModalContainer.jsx